<template>
    <syain-update />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import SyainUpdate from '@/components/syain/Update.vue'

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      'syain-update': SyainUpdate
    }
})
</script>
